import callApi from '../../util/apiCaller';
import {
  DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES,
  DASHBOARD_REQUEST_EDIT_WIN_LOSS_OPPORTUNITY_FEEDBACKS,
  DASHBOARD_REQUEST_EDIT_WIN_LOSS_ACCOUNT_FEEDBACKS,
} from '../Dashboard/DashboardActions';

export function fetchOpportunity(id) {
  return (dispatch) => {
    const hasNoDecision = true;
    const empty = {
      status: null,
      errors: null,
      opportunities: [],
      owners: {},
      accounts: {},
      hasNoDecision,
      users: {},
      isApex: true,
    };
    dispatch({
      type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES,
      ...empty,
      status: 'loading',
      errors: null,
      hasNoDecision,
    });

    const p = callApi(`apex/opportunities/${id}`, 'POST');
    p.then(
      (opportunity) => {
        const owner = opportunity.owner || {};
        const account = opportunity.account || {};
        const results = {
          opportunities: [opportunity],
          accounts: { [account.account_id]: account },
          owners: { [owner.user_id]: owner },
          users: {},
        };
        const d = dispatch({
          type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES, ...results, status: 'loaded', errors: null, hasNoDecision, isApex: true,
        });
        dispatch({
          type: DASHBOARD_REQUEST_EDIT_WIN_LOSS_OPPORTUNITY_FEEDBACKS, opportunity,
        });
        return d;
      },
      errors => dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES, ...empty, status: 'error', errors: errors.data || errors, hasNoDecision,
      }),
    );
    return p;
  };
}


export function fetchAccount(id) {
  return (dispatch) => {
    const hasNoDecision = true;
    const empty = {
      status: null,
      errors: null,
      opportunities: [],
      owners: {},
      accounts: {},
      hasNoDecision,
      users: {},
      isApex: true,
    };
    dispatch({
      type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES,
      ...empty,
      status: 'loading',
      errors: null,
      hasNoDecision,
    });

    const p = callApi(`apex/accounts/${id}`, 'POST');
    p.then(
      (result) => {
        const owner = result.owner || {};
        const account = result.account || {};

        const results = {
          opportunities: result.opportunities || [],
          accounts: { [account.account_id]: account },
          owners: { [owner.user_id]: owner },
          users: {},
        };
        const d = dispatch({
          type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES, ...results, status: 'loaded', errors: null, hasNoDecision, isApex: true,
        });
        dispatch({
          type: DASHBOARD_REQUEST_EDIT_WIN_LOSS_ACCOUNT_FEEDBACKS, account,
        });
        return d;
      },
      errors => dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES, ...empty, status: 'error', errors: errors.data || errors, hasNoDecision,
      }),
    );
    return p;
  };
}